export default __webpack_public_path__ + "static/media/landline.dc26f6ef.webp";